module.exports = {
  lib: require('./emojis'),
  ordered: require('./ordered')
}



//////////////////
// WEBPACK FOOTER
// ./~/emojilib/index.js
// module id = 831
// module chunks = 0